import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgPrijsopbouw = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#A8D3AF"
      fillRule="evenodd"
      d="M30 34H10V6h14l3 3 3 3z"
      clipRule="evenodd"
    />
    <path
      fill="#6FBC85"
      fillRule="evenodd"
      d="m30 12-2.95-2.93L24 6v6z"
      clipRule="evenodd"
    />
    <path
      fill="#00A75D"
      d="M21 15.5h-9v1h9zM25 15.5V14h-1v1.5h-1.5v1H24V18h1v-1.5h1.5v-1zM21 21.5h-9v1h9zM25 20h-1v1.5h-1.5v1H24V24h1v-1.5h1.5v-1H25zM13 27h-1v4h12v-1H13z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgPrijsopbouw);

export default ForwardRef;
